import { MMHG } from './consts/math';

export const getDate = (date) => {
    return new Date(date * 1000).toLocaleString('uk-UA', {
        day: 'numeric',
        month: 'long',
        weekday: 'long'
    });
};

export const getDateSun = (date) => {
    return new Date(date * 1000).toLocaleString('uk-UA', {
        hour: '2-digit',
        minute: '2-digit'
    });
};

export const getAT = (at) => Math.ceil(at * MMHG);

export const getDayLong = (riseSun, setSun) => {
    const res = setSun - riseSun;
    const hours = res / 3600 ^ 0;
    const minutes = (res - hours * 3600) / 60 ^ 0;
    return `${hours} годин ${minutes} хвилин`;
};

export const formatDate = (date) => {
    const time = date.substr(11, 5);
    const day = date.substr(8, 2);
    const mounth = date.substr(5, 2);
    return `${day}.${mounth} ${time}`;
};

export const formatDateArray = (date) => {
    const time = date.substr(11, 5);
    const day = date.substr(8, 2);
    const mounth = date.substr(5, 2);
    return [`${day}.${mounth}`, `${time}`];
};

export const formatDay = (date) => {
    const day = date.substr(8, 2);
    const mounth = date.substr(5, 2);
    return `${day}.${mounth}`;
};